import { KEYS } from "utils/constants";

export const setPaginationHistory = ({ footprint, value, take, count }) => {
  const skip = (value - 1) * take;
  localStorage.setItem(
    KEYS.PAGINATION,
    JSON.stringify({
      ...JSON.parse(localStorage.getItem(KEYS.PAGINATION) || "{}"),
      [footprint]: { value, skip: skip < count ? skip : 0, take, count },
    }),
  );
};

export const getPaginationHistory = (footprint) => {
  const paginationHistory = JSON.parse(
    localStorage.getItem(KEYS.PAGINATION) || "{}",
  );
  return paginationHistory[footprint] || {};
};

export const clearPaginationHistory = (footprint) => {
  localStorage.setItem(
    KEYS.PAGINATION,
    JSON.stringify({
      ...JSON.parse(localStorage.getItem(KEYS.PAGINATION) || "{}"),
      [footprint]: undefined,
    }),
  );
};

export const decreasePagination = (footprint) => {
  const pagination = getPaginationHistory(footprint);
  setPaginationHistory({
    footprint,
    ...pagination,
    count: (pagination.count -= 1),
  });
};
